module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDataLoaded) ? _c('div', {
    attrs: {
      "id": "view-panorama-container"
    }
  }, [_c('div', {
    staticClass: "container is-fluid levebar-container"
  }, [_c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left is-hidden-mobile"
  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
    attrs: {
      "list": _vm.breadcrumbList
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.panorama) ? _c('panorama-container', {
    attrs: {
      "panoramaData": _vm.panorama
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4101febc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panorama/index.vue
// module id = 315
// module chunks = 1